// extracted by mini-css-extract-plugin
export default {"backBtn":"BackBtn_backBtn__d9VSv"};